import getURLParams from 'utils/DOM/getURLParams'
import { getTodayDate, stringToDate } from '@hc-frontend/utils'

const today = getTodayDate()
const firstNovemberDate = `11/01/${today.getFullYear()}`
const firstNovember = stringToDate(firstNovemberDate)
const isTodayFirstNovember = today.getTime() === firstNovember.getTime()
const URLParams = getURLParams()
const quoteDate = isTodayFirstNovember ? firstNovemberDate : URLParams['quote-date']
const hasQuoteDate = !!quoteDate

function getLastStartDate() {
  return hasQuoteDate ? 61 : 60
}

function getQuoteDate() {
  return quoteDate
}

export { getLastStartDate, getQuoteDate }
